// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__6WQQ3","col":"styles_col__GHr41","fulfillmentStatus":"styles_fulfillmentStatus__3dpfV","emailCol":"styles_emailCol__umkbD"};